import { render, staticRenderFns } from "./my-code-img.vue?vue&type=template&id=04600c0e&scoped=true"
import script from "./my-code-img.vue?vue&type=script&lang=js"
export * from "./my-code-img.vue?vue&type=script&lang=js"
import style0 from "./my-code-img.vue?vue&type=style&index=0&id=04600c0e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04600c0e",
  null
  
)

export default component.exports